import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
// import './assets/css/theme-green/index.css'; // 浅绿色主题
import './assets/css/icon.css';

import $ from 'jquery'

import './assets/css/reset.css'
import './assets/iconfont.css'

import store from "./store/store"

import './components/common/directives';
import 'babel-polyfill';

import global_ from './utils/Global';
import VCharts from 'v-charts';

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

import Clipboard from 'v-clipboard'
Vue.use(Clipboard)

import Share from 'vue-social-share'
Vue.use(Share);
import 'vue-social-share/dist/client.css';

import beaseInfo from "./utils/getBeaseInfo";
/**拖拽 */
import VueDND from 'awe-dnd'

//引入富文本
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


// import { ImageDrop } from 'quill-image-drop-module'
// import ImageResize from 'quill-image-resize-module'
// Quill.register('modules/imageDrop', ImageDrop)
// Quill.register('modules/imageResize', ImageResize)
//.ie11 不兼容
let IsIE = !!window.ActiveXObject || "ActiveXObject" in window;
//  console.log(IsIE);
//其实用if，或try...catch一种就可以了
if(!IsIE){
  // try {
    var { ImageDrop } = require('quill-image-drop-module');
    var ImageResize = require('quill-image-resize-module').default;
 
    // console.log('ImageDrop',ImageDrop);
    // console.log('ImageResize',ImageResize);
 
    Quill.register('modules/imageDrop', ImageDrop)
    Quill.register('modules/imageResize', ImageResize)
 
  // } catch(err){
  //   console.log(err);
  // }

}
Vue.use(VueQuillEditor)
// Vue.config.productionTip = false;
// import vueSwiper from 'vue-awesome-swiper'

// import 'swiper/dist/css/swiper.css'  //引入样式
// import VueQuillEditor from 'vue-quill-editor'   //富文本插件

// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

// import Vue from 'vue'

import VueI18n from 'vue-i18n'

// import i18n from './lang'
Vue.use(VueI18n) // 通过插件的形式挂载，通过全局方法 Vue.use() 使用插件
const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
  //  locale: 'en-US', // 语言标识 //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': require('./VueI18n/language-zh'),  //
    'en-US': require('./VueI18n/language-en')
  }
})
Vue.config.productionTip = false
// import VueCropper from 'vue-cropper'
// Vue.use(VueCropper)

// 引入mockjs
// import Mock from './mock' // 刚刚手写的mock.js文件
// Vue.use(Mock)

Vue.config.productionTip = false;
Vue.use(ElementUI, {
  size: 'small'
});
Vue.use(VCharts)
Vue.use(VueDND)
// Vue.prototype.$api = api;

Vue.prototype.GLOBAL = global_;

// // 使用钩子函数对路由进行权限跳转
// router.beforeEach((to, from, next) => {
//   if (to.path == '/login' || to.path == '/403' || to.path == '/404') {
//     next();
//   } else {
//     let login_name = localStorage.getItem("login_name"); //内部有判断如果本地浏览器中用户信息为空则跳往登录
//     if (login_name == null) {
//       next('/login')
//     } else {
//       //判断用户跳往的权限
//       let routerList = localStorage.getItem("user_router");
//       let sign = routerList.indexOf(to.name);
//       if (sign == -1) { //无权访问
//         next('/403');
//       } else {
//         next();
//       }
//     }

//   }
// });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js